require('./lbaGrid.scss');

const $inject = [];

const lbaGrid = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '=',
      results: '<'
    },
    bindToController: true,
    controller: 'lbaGridCtrl',
    controllerAs: 'vm',
    template: require('./lbaGrid.html')
  }
};

lbaGrid.$inject = $inject;

export default lbaGrid;



// WEBPACK FOOTER //
// ./src/components/lbaGrid/lbaGridDir.js